module.exports = __webpack_public_path__ + "static/img/8.9d50dc1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/eng/8.png
// module id = hsnV
// module chunks = 0